import React, { Component } from "react";
import weui from "weui.js";
import HomeIcon from "../../assets/svg/home.svg";
import {
  Button,
  Cell,
  CellBody,
  CellButton,
  CellFooter,
  CellHeader,
  Cells,
  CellsGroup,
  CellsTips,
  CellsTitle,
  Checkbox,
  Footer,
  Form,
  FormArea,
  FormDesc,
  FormTips,
  FormTitle,
  IconInfo,
  IconSuccess,
  IconWaiting,
  IconWarn,
  Input, Label,
  Link,
  MediaBoxAppMsg,
  MediaBoxText,
  Panel,
  PanelBody,
  PanelFooter,
  PanelHeader,
  Radio, Select, Switch, TextArea
} from "../weui";


export class WeUIDemo extends Component {
  static displayName = WeUIDemo.name;

  state = {
    val: "hehe",
    curr: 0,
    navCur: 0
  };

  render () {
    const links = [
      { title: "链接1", href: "https://abc.com" },
      { title: "链接2", href: "https://abc.com" }
    ];

    return (
      <>
        <Button type="primary" loading>Hehe</Button>
        <Button onClick={ e => alert("haha") } loading>Hehe</Button>
        <Button type="warn" loading >Hehe</Button>
        <Button type="warn" mini loading disabled onClick={ e => alert("fdsa") } >Hehe</Button>

        <IconSuccess />
        <IconInfo />
        <IconWarn />
        <IconWaiting />
        
        <Panel access>
          <PanelHeader>图文</PanelHeader>
          <PanelBody>
            <MediaBoxAppMsg icon={ HomeIcon } title="标题1" desc="哈哈喇吧别拿哈哈喇吧别拿哈哈喇吧别拿哈哈喇吧别拿哈哈喇吧别拿哈哈喇吧别拿" />
            <MediaBoxText title="标题2" desc="fdsafkdsf dafdsfadskfasdf" infos={ ["来源", "时间", "|其它"] } />
          </PanelBody>
          <PanelFooter>
            <Cell access active link>
              <CellBody>加载更多</CellBody>
              <CellFooter></CellFooter>
            </Cell>
          </PanelFooter>
        </Panel>
        
        <Form>
          <CellsGroup form>
            <CellsTitle>Hello</CellsTitle>
            <Cells>
              <Cell active access link onClick={ e => alert("click") }>
                <CellHeader>
                  <Label>label</Label>
                  <div className="weui-cell__desc">descriptions.</div>
                </CellHeader>
                <CellBody>
                  Body
                  <div className="weui-cell__desc">descriptions.</div>
                </CellBody>
                <CellFooter></CellFooter>
              </Cell>
              <Cell active readOnly  htmlFor="elInput001">
                <CellHeader>
                  <span className="weui-label">label</span>
                </CellHeader>
                <CellBody>
                  <Input id="elInput001" placeholder="请输入..." readOnly />
                </CellBody>
                <CellFooter></CellFooter>
              </Cell>
              <Cell active vcode htmlFor="elInput002">
                <CellHeader>
                  <span className="weui-label">验证码</span>
                </CellHeader>
                <CellBody flex>
                  <Input id="elInput002" cell placeholder="验证码" />
                  <Button vcode>获取验证码</Button>
                </CellBody>
              </Cell>
            </Cells>
            <CellsTips><Link href="#">World</Link></CellsTips>

            <Cells checkbox>
              <Cell htmlFor="elInput003" checkbox>
                <CellHeader>
                  <Checkbox id="elInput003" />
                </CellHeader>
                <CellBody>Options 1</CellBody>
              </Cell>
              <Cell htmlFor="elInput004" checkbox>
                <CellHeader>
                  <Checkbox id="elInput004" />
                </CellHeader>
                <CellBody>Options 2</CellBody>
              </Cell>
              <Cell href="#" active link onClick={ e => weui.alert("haha") }>
                <CellBody>Load More</CellBody>
              </Cell>
            </Cells>

            <Cells radio>
              <Cell htmlFor="elInput005" radio>
                <CellBody>Options 1</CellBody>
                <CellFooter>
                  <Radio id="elInput005" name="radio" />
                </CellFooter>
              </Cell>
              <Cell htmlFor="elInput006" checkbox>
                <CellBody>Options 2</CellBody>
                <CellFooter>
                  <Radio id="elInput006" name="radio" />
                </CellFooter>
              </Cell>
              <Cell href="#" active link onClick={ e => weui.topTips("hfhfsa", 5000) }>
                <CellBody>Load More</CellBody>
              </Cell>
            </Cells>

            <Cells>
              <Cell htmlFor="el001" sw>
                <CellBody>Switch</CellBody>
                <CellFooter>
                  <Switch id="el001" />
                </CellFooter>
              </Cell>
              <Cell htmlFor="el002" sw disabled>
                <CellBody>Switch</CellBody>
                <CellFooter>
                  <Switch id="el002" disabled />
                </CellFooter>
              </Cell>
            </Cells>

            <Cells>
              <Cell htmlFor="el003" select>
                <CellBody>
                  <Select id="el003">
                    <option value={ 0 }>QQ</option>
                    <option value={ 1 }>微信</option>
                  </Select>
                </CellBody>
              </Cell>
              <Cell htmlFor="el004" selectBefore>
                <CellHeader>
                  <Select id="el004">
                    <option value={ 0 }>QQ</option>
                    <option value={ 1 }>微信</option>
                  </Select>
                </CellHeader>
                <CellBody>
                  <Input />
                </CellBody>
              </Cell>
              <Cell htmlFor="el005" selectAfter>
                <CellHeader>
                  <span className="weui-label">Hehe</span>
                </CellHeader>
                <CellBody>
                  <Select id="el005">
                    <option value={ 0 }>QQ</option>
                    <option value={ 1 }>微信</option>
                  </Select>
                </CellBody>
              </Cell>
            </Cells>

            <Cells>
              <CellButton icon={ HomeIcon } type="primary">Cancel</CellButton>
            </Cells>

            <CellsTitle>Description</CellsTitle>
            <Cells>
              <Cell htmlFor="el006" active>
                <CellBody>
                  <TextArea id="el006" maxLength={ 200 } showCounter/>
                </CellBody>
              </Cell>
            </Cells>
          </CellsGroup>
        </Form>

        <Form>
          <FormArea type="text">
            <FormTitle>Hello</FormTitle>
            <FormDesc>World......</FormDesc>
          </FormArea>
          
          <FormArea type="control">
            <CellsGroup form>
              <CellsTitle>Hehehe</CellsTitle>
              <Cells>
                <Cell htmlFor="in001"> 
                  <CellHeader><span className="weui-label">haha</span></CellHeader>
                  <CellBody>
                    <Input id="in001" placeholder="fdsfsafds" />
                  </CellBody>
                </Cell>
                <Cell htmlFor="in002">
                  <CellHeader><span className="weui-label">hehe</span></CellHeader>
                  <CellBody>
                    <Input id="in002" placeholder="fdsafdsa" value={ this.state.val } onChange={ e => this.setState({ val: e.target.value }) } />
                  </CellBody>
                </Cell>
                <Cell active htmlFor="in003" vcode>
                  <CellHeader>
                    <span className="weui-label">验证码</span>
                  </CellHeader>
                  <CellBody flex>
                    <Input id="in003" cell placeholder="验证码" />
                    <Button vcode>获取验证码</Button>
                  </CellBody>
                </Cell>
              </Cells>
            </CellsGroup>
          </FormArea>
          
          <FormArea type="tips">
            <FormTips>hahahahah</FormTips>
          </FormArea>
          
          <FormArea type="opr">
            <Button type="primary" onClick={ e => weui.alert(JSON.stringify(this.state)) }>OK</Button>
            <CellButton icon={ HomeIcon } type="warn" onClick={ e => {
              weui.picker([
                { label: "op1", value: 0 },
                { label: "op2", value: 1 },
                { label: "op3", value: 2 }
              ], {
                defaultValue: 2,
                onConfirm: e => weui.alert(JSON.stringify(e))
              });
            } }>Cancel</CellButton>
          </FormArea>
          
          <FormArea type="extra">
            <Footer copyright="Copyright (c) 2022 snowfoxzx" links={ links } />
          </FormArea>
        </Form>

      









        { /*<TabBar>*/ }
        { /*  <TabBarItem label="首页" active={isActive(0)} onClick={e => tabBarClick(0)} icon={HomeIcon} badge="8" />*/ }
        { /*  <TabBarItem label="充值" active={isActive(1)} onClick={e => tabBarClick(1)} icon={MoneyIcon} />*/ }
        { /*  <TabBarItem label="账单" active={isActive(2)} onClick={e => tabBarClick(2)} icon={BillIcon} badge="" />*/ }
        { /*  <TabBarItem label="我的" active={isActive(3)} onClick={e => tabBarClick(3)} icon={UserIcon} />*/ }
        { /*</TabBar>*/ }
        { /*<AgreementPage btnWrap>*/ }
        { /*  <AgreementContent>*/ }
        { /*    fdsfafdsfaf*/ }
        { /*    fdsfafdsfafafdsfdsafdsadsaf*/ }
        { /*    fdsafas*/ }
        { /*  </AgreementContent>*/ }
        { /*  <AgreementButtons>*/ }
        { /*    <Button type="primary">Agree</Button>*/ }
        { /*    <Button>NO!</Button>*/ }
        { /*  </AgreementButtons>*/ }
        { /*</AgreementPage>*/ }
      </>
    );
  }
}
